import React from "react";
import styles from "./scss/dialpadmainnumber.module.scss";
import callgreen from "../../../styles/images/callgreen.svg";

type dialPadNumberProps= {
  mainCallWindow :any;
  keyPressEventProps:Function;
  ContactList:any;
};
export default function DialPadNumber({mainCallWindow, keyPressEventProps, ContactList} :dialPadNumberProps) {

  const placeNewCall = () => { mainCallWindow(); };
  let timer:any=null;
  let plus=0;
  
  const keyPressEvent = (key: any) => {
    keyPressEventProps(key);
  };
  const onKeyPressed = (e:any) => {
    if(e.button === 0){
      const longpressfunc=()=>{
        setTimeout(()=>{ plus=1; },600);
      };
      timer=longpressfunc();
    }
  };

  const onKeyUpPressed=(e:any)=>{
    clearTimeout(timer);
    if (plus === 1) { keyPressEventProps("+"); }
    else{ keyPressEventProps("0"); }
  };
  return (
    <>
      <div className={styles.dialscreens}>
        <div className={styles.chatDialPadInner} onClick={ () => keyPressEvent('1')} id='dial1'>
          <div className={styles.chatDialPadNumber}>1</div>
        </div>
        <div className={styles.chatDialPadInner} onClick={ () => keyPressEvent('2')} id='dial2'>
          <div className={styles.chatDialPadNumber}>2</div>
          <div className={styles.chatDialPadAlpha}>ABC</div>
        </div>
        <div className={styles.chatDialPadInner} onClick={ () => keyPressEvent('3')} id='dial3'>
          <div className={styles.chatDialPadNumber}>3</div>
          <div className={styles.chatDialPadAlpha}>DEF</div>
        </div>
        <div className={styles.chatDialPadInner} onClick={ () => keyPressEvent('4')} id='dial4'>
          <div className={styles.chatDialPadNumber}>4</div>
          <div className={styles.chatDialPadAlpha}>GHI</div>
        </div>
        <div className={styles.chatDialPadInner} onClick={ () => keyPressEvent('5')} id='dial5'>
          <div className={styles.chatDialPadNumber}>5</div>
          <div className={styles.chatDialPadAlpha}>JKL</div>
        </div>
        <div className={styles.chatDialPadInner} onClick={ () => keyPressEvent('6')} id='dial6'>
          <div className={styles.chatDialPadNumber}>6</div>
          <div className={styles.chatDialPadAlpha}>MNO</div>
        </div>
        <div className={styles.chatDialPadInner} onClick={ () => keyPressEvent('7')} id='dial7'>
          <div className={styles.chatDialPadNumber}>7</div>
          <div className={styles.chatDialPadAlpha}>PQRS</div>
        </div>
        <div className={styles.chatDialPadInner} onClick={ () => keyPressEvent('8')} id='dial8'>
          <div className={styles.chatDialPadNumber}>8</div>
          <div className={styles.chatDialPadAlpha}>TUV</div>
        </div>
        <div className={styles.chatDialPadInner} onClick={ () => keyPressEvent('9')} id='dial9'>
          <div className={styles.chatDialPadNumber}>9</div>
          <div className={styles.chatDialPadAlpha}>WXYZ</div>
        </div>
        <div className={`${styles.chatDialPadInner} ${styles.specials}`}  onClick={ () => keyPressEvent('*')} id='dial*'>
          <div className={styles.chatDialPadNumber}>*</div>
          <div className={styles.chatDialPadChar}>,</div>
        </div>
        <div className={styles.chatDialPadInner}
          onMouseDown={onKeyPressed} tabIndex={0}
           onClick={onKeyUpPressed}
        >
          <div className={styles.chatDialPadNumber} id='dial0'>0</div>
          <div className={styles.chatDialPadChar} >+</div>
        </div>
        <div className={styles.chatDialPadInner} onClick={ () => keyPressEvent('#')} id='dial#'>
          <div className={styles.chatDialPadNumber}>#</div>
        </div>
        <div className={styles.chatDialCall} >
          <img src={callgreen} alt="" onClick={placeNewCall} id='dialCall'/>
          <span className={styles.bookscontact} onClick={ContactList}></span>
        </div>
      </div>
      <div onClick={ () => keyPressEvent('+')} id='dial+'></div>
    </>
  );
};

